export default "__VITE_ASSET__Dx4yZrw2__"